<p-select
  [options]="caregivers"
  [(ngModel)]="selectedCaregiver"
  (ngModelChange)="onChange($event)"
  [loading]="isLoading"
  [filter]="true"
  (onFilter)="onFilter($event)"
  [showClear]="showClear"
  optionLabel="displayName"
  dataKey="sKey"
  [size]="size"
  inputId="caregiverPickerCompact"
  [placeholder]="placeholder"
  [disabled]="disabled"
  appendTo="body"
>
  <ng-template pTemplate="loader" let-options="options">
    <div class="flex align-items-center p-2" style="height: 44px">
      <i class="pi pi-spin pi-spinner" [style]="{ 'font-size': '1.5rem' }"></i>
    </div>
  </ng-template>
  <ng-template let-caregiver pTemplate="item">
    <div class="flex align-items-center">
      <div class="flex flex-column">
        <span class="font-medium">{{ caregiver.firstName }} {{ caregiver.lastName }}</span>
      </div>
    </div>
  </ng-template>
</p-select>
